// Before Firefox 58, nearest and center values for the block option were unsupported.
enum UnsupportedFirefoxBlockValues {
    center = 'center',
    nearest = 'nearest',
}

const areBlockOptionsSupported = ((): boolean => {
    try {
        const element = document.createElement('div');
        element.scrollIntoView({ block: UnsupportedFirefoxBlockValues.center });
        element.scrollIntoView({ block: UnsupportedFirefoxBlockValues.nearest });

        return true;
    } catch {
        return false;
    }
})();

type Options = boolean | ScrollIntoViewOptions;

const getSupportedOptions = (options?: Options): Options | undefined => {
    if (typeof options === 'boolean' || !options) {
        return options;
    }

    const { block } = options;
    if (!block) {
        return options;
    }

    if (!areBlockOptionsSupported && block in UnsupportedFirefoxBlockValues) {
        return {
            ...options,
            block: 'start',
        };
    }

    return options;
};

type ScrollIntoView = (element: Element, options?: Options) => void;
const scrollIntoView: ScrollIntoView = (element, options) => {
    const supportedOptions = getSupportedOptions(options);
    element.scrollIntoView(supportedOptions);
};

export default scrollIntoView;
